module.exports = __webpack_public_path__ + "img/jilu_normal.681e4b91.png";